import { formatClock, remainingMs, useServerNow } from "../lib/time.ts";
import type { PhaseView } from "../lib/types.ts";

/** A phase or card timer, corrected for the server clock offset. */
export function Countdown({
  phase,
  deadline,
  testId,
}: {
  phase?: Pick<PhaseView, "deadline" | "paused" | "remainingMs">;
  deadline?: number | null;
  testId?: string;
}) {
  const now = useServerNow();
  const ms = phase
    ? remainingMs(phase, now)
    : deadline != null
      ? Math.max(0, deadline - now)
      : null;
  if (ms === null) return null;
  return (
    <span
      className={`clock ${ms <= 30_000 ? "low" : ""}`}
      data-testid={testId}
      role="timer"
      aria-label={`${formatClock(ms)} left`}
    >
      {formatClock(ms)}
    </span>
  );
}
